/**
 * SQL 튜닝 수준 — 에이전트가 **어디까지 해도 되는지**의 상한.
 *
 * 값은 **백엔드 `modules/assistant/tuning/tuningLevel.js` 의 LEVELS 와 같아야 한다.**
 * 어긋나면 화면에는 뜨는데 서버가 조용히 기본값으로 떨어뜨린다 — 사용자는 고른 대로
 * 동작한다고 믿는다. `wiring.test.js` 가 두 목록을 대조한다.
 *
 * 라벨은 i18n 이 가진다(`assistant:tuningLevel.*`). 여기에 문구를 적지 않는다.
 */
export const TUNING_LEVELS = [1, 2, 3, 4, 5, 6];

/** 기본값 — L4(데이터 분포까지, 대안 실행·임시 인덱스는 하지 않는다 — 2026-10-29 사용자 결정). 올리는 것은 사용자가 고른다. */
export const DEFAULT_TUNING_LEVEL = 4;

export const normalizeTuningLevel = (v) => (TUNING_LEVELS.includes(Number(v)) ? Number(v) : DEFAULT_TUNING_LEVEL);
